import { memo } from 'react'

import { onDiscountByPaymentMethodViewedDataLayer } from 'catalog/utils/data-layer'

import * as S from './styled'

interface PriceTagLabelProps {
  isOutlet: boolean
  isOffer: boolean
  isDiscountByPaymentMethod: boolean
  paymentMethodsDiscount: string
  discountPercentage: number
}

const PriceTagLabel = ({
  isOutlet,
  isOffer,
  isDiscountByPaymentMethod,
  paymentMethodsDiscount,
  discountPercentage
}: PriceTagLabelProps) => {
  const showDiscount = discountPercentage > 0

  if (isOutlet && !isDiscountByPaymentMethod) {
    return (
      <S.PriceTagLabel>
        <span>BLACK FRIDAY</span>

        {showDiscount && <span>-{discountPercentage}%</span>}
      </S.PriceTagLabel>
    )
  }

  if (isOutlet && isDiscountByPaymentMethod) {
    onDiscountByPaymentMethodViewedDataLayer(
      paymentMethodsDiscount,
      discountPercentage,
      isOutlet
    )

    return (
      <S.PriceTagLabel isOutletByPaymentMethod>
        <span>BLACK FRIDAY</span>

        {showDiscount && (
          <span data-cy="discount-by-payment-method">
            -{discountPercentage}% {paymentMethodsDiscount}
          </span>
        )}
      </S.PriceTagLabel>
    )
  }

  if (isDiscountByPaymentMethod) {
    onDiscountByPaymentMethodViewedDataLayer(
      paymentMethodsDiscount,
      discountPercentage
    )

    return (
      <S.PriceTagLabel isPromotionalPaymentMethod>
        <span>OFERTA</span>

        {showDiscount && (
          <span data-cy="discount-by-payment-method">
            -{discountPercentage}% {paymentMethodsDiscount}
          </span>
        )}
      </S.PriceTagLabel>
    )
  }

  if (isOffer) {
    return (
      <S.PriceTagLabel isPromotional>
        <span>OFERTA</span>

        {showDiscount && <span>-{discountPercentage}%</span>}
      </S.PriceTagLabel>
    )
  }

  return null
}

export default memo(PriceTagLabel)
